import Image from 'components/image/image'
import Heading from 'components/heading/heading'
import Meta from 'components/meta/meta'
import Rich from 'components/rich/rich'
import Bread from 'components/bread/bread'
import Articles from 'components/articles/articles'
import styles from 'styles/page/article.module.scss'
import { getData, getList } from 'utils/api'
import { cn, getRoute } from 'utils/helpers'

export default function Page(props) {
    const bread = [
        {
            url: getRoute('buyerblog'),
            name: 'Tinklaraštis pirkėjams'
        },
        {
            url: getRoute('blog-category', { slug: props.category_slug, buyers: props.buyers }),
            name: props.category_name
        }
    ]

    return (
        <>
            <Meta title={props.name} description={props.excerpt} image={props.image} />
            <article className={cn(styles.blogPost, 'mb72')}>
                <div className={styles.left}>
                    <Image
                        src={props.image}
                        alt={props.name}
                        layout="responsive"
                        objectFit="cover"
                        priority={true}
                        width={360}
                        height={360}
                    />
                </div>
                <div className={styles.right}>
                    <Bread items={bread} small={1} className="mb24" />
                    <div className={styles.inline}>
                        <Heading tag="h1" size="36">
                            {props.name}
                        </Heading>
                    </div>
                    <Rich alt content={props.content} />
                    <p>{props.date}</p>
                </div>
            </article>
            {props.articles && !!props.articles.length && (
                <section>
                    <Heading tag="h2" size="36" center className={cn(styles.heading, 'mb72')}>
                        Kiti straipsniai šioje kategorijoje
                    </Heading>
                    <Articles articles={props.articles} />
                </section>
            )}
        </>
    )
}

export async function getStaticProps(context) {
    return await getData(`article/buyers/${context.params.slug}`)
}

export async function getStaticPaths() {
    return getList('articles-list/buyers')
}
